import React from 'react';
import { Redirect } from 'react-router-dom';

import Layout from '../../layout/Layout';
import './styles.css';

const NotFound = () => {
  return (
    <Redirect to="/" />
  );
};

export default NotFound;
